import { Container } from 'unstated';

// Tempo de espera antes de ocultar o indicador de processamento. Além de garantir
// que ele fique visível por tempo suficiente para não parecer que a tela apenas
// "piscou", mantém ele visível no intervalo entre requisições encadeadas. Sem essa
// espera, telas que fazem várias requisições em sequência exibem e escondem o
// indicador a cada requisição, dando a impressão de que a tela recarrega várias
// vezes quando o servidor está lento.
const TEMPO_ESPERA_OCULTAR = 250;

export interface ProcessandoState {
  quantidade: number;
}

export class ProcessandoContainer extends Container<ProcessandoState> {
  state: ProcessandoState = {
    quantidade: 0
  };

  atualizarQuantidade = (promessa: Promise<any>) => {
    this.setState(prevState => ({
      quantidade: prevState.quantidade + 1
    }));

    const removerQuantidade = () => {
      setTimeout(() => {
        this.setState(prevState => ({
          quantidade: prevState.quantidade - 1
        }));
      }, TEMPO_ESPERA_OCULTAR);
    };

    promessa.then(removerQuantidade, removerQuantidade);
  };
}

export default new ProcessandoContainer();
